"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLuxonFromEventrDate = getLuxonFromEventrDate;
exports.getLuxonFromLegacyEventrDate = getLuxonFromLegacyEventrDate;
exports.getLuxonFromTimeString = getLuxonFromTimeString;
const luxon_1 = require("luxon");
const commonUtils_1 = require("../commonUtils");
const dateTypeRegEx_1 = require("./dateTypeRegEx");
const eventr_interface_1 = require("../interfaces/eventr.interface");
/**
 * Given valid date time string will return correctly timezoned luxon datetime obj
 * If Override then uses county code
 * If Not then uses +- val
 */
function getLuxonFromEventrDate(dateTimeString) {
    if (!(0, dateTypeRegEx_1.isEventrDate)(dateTimeString)) {
        /// invalid datetime string
        return false;
    }
    /// get date and time parts.
    const [dateString, timeString] = dateTimeString.split('T');
    const [year, month, day] = dateString.split('-');
    const isOverride = dateTimeString.includes('O');
    let timezone = 'utc';
    if (isOverride) {
        timezone = (0, eventr_interface_1.getTimezoneName)(parseInt(timeString.slice(6), 10));
    }
    try {
        const newLuxonDateTime = luxon_1.DateTime.fromObject({
            year: parseInt(year, 10),
            month: parseInt(month, 10),
            day: parseInt(day, 10),
            hour: parseInt(timeString.slice(0, 2), 10),
            minute: parseInt(timeString.slice(3, 5), 10),
        }, { zone: timezone });
        if (newLuxonDateTime.isValid) {
            return newLuxonDateTime;
        }
        else {
            return false;
        }
    }
    catch (error) {
        (0, commonUtils_1.spError)('Error with date parse into luxon', error);
        return false;
    }
}
function getLuxonFromLegacyEventrDate(dateTimeString) {
    if (!(0, dateTypeRegEx_1.isLegacyEventrDate)(dateTimeString)) {
        /// invalid datetime string
        return false;
    }
    /// get date and time parts.
    const [dateString, timeString] = dateTimeString.split('T');
    const [year, month, day] = dateString.split('-');
    const offsetMinits = parseInt(timeString.slice(9, 11), 10);
    const offsetHours = parseInt(timeString.slice(6, 8), 10);
    try {
        let newLuxonDateTime = luxon_1.DateTime.fromObject({
            year: parseInt(year, 10),
            month: parseInt(month, 10),
            day: parseInt(day, 10),
            hour: parseInt(timeString.slice(0, 2), 10),
            minute: parseInt(timeString.slice(3, 5), 10),
        }, { zone: 'utc' });
        /// For either override or not, will plus/minus the timezone offset for luxon to know.
        /// Only for not overridden strings.
        if (dateTimeString.includes('N')) {
            if (timeString[5] === '-') {
                newLuxonDateTime = newLuxonDateTime.plus({
                    minutes: offsetMinits,
                    hours: offsetHours,
                });
            }
            else if (timeString[5] === '+') {
                newLuxonDateTime = newLuxonDateTime.minus({
                    minutes: offsetMinits,
                    hours: offsetHours,
                });
            }
        }
        return newLuxonDateTime;
    }
    catch (error) {
        (0, commonUtils_1.spError)('Error with date parse into luxon', error);
        return false;
    }
}
function getLuxonFromTimeString(timeString) {
    if (!(0, dateTypeRegEx_1.isTimeString)(timeString)) {
        return false;
    }
    try {
        const newLuxonDateTime = luxon_1.DateTime.fromObject({
            hour: timeString.length >= 2
                ? parseInt(timeString.slice(0, 2), 10)
                : undefined,
            minute: timeString.length >= 5
                ? parseInt(timeString.slice(3, 5), 10)
                : undefined,
            second: timeString.length >= 8
                ? parseInt(timeString.slice(6, 8), 10)
                : undefined,
            millisecond: timeString.length >= 9
                ? parseInt(timeString.slice(9), 10)
                : undefined,
        });
        return newLuxonDateTime;
    }
    catch (error) {
        (0, commonUtils_1.spError)('Error with date parse into luxon', error);
        return false;
    }
}
